import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetJournalReportQuery } from "../../../services/Reports";
import {
  getJournalReportRequest,
  getJournalReportFailure,
  getJournalReportSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allJournalReport,
    isLoading: journalReportLoading,
    isError: journalReportError,
  } = useGetJournalReportQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.journalReportPageNo,
    pageSize: state.journalReportPageSize,
    fromDate: new Date(state.journalReportFromDate).toLocaleDateString(),
    toDate: new Date(state.journalReportToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (journalReportLoading) {
      dispatch(getJournalReportRequest());
    }
    if (journalReportError) {
      dispatch(getJournalReportFailure(journalReportError));
    }
    if (allJournalReport) {
      dispatch(
        getJournalReportSuccess({
          data: allJournalReport.data.journalReport[0].data || [],
          totalPages:
            allJournalReport.data.journalReport[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allJournalReport,
    profileData,
    state.journalReportFromDate,
    state.journalReportToDate,
    state.journalReportPageNo,
    state.journalReportPageSize,
  ]);
  return <></>;
};
export default Content;
